/**
 * Resolve the API base URL at runtime.
 *
 * Normally this is the build-time `NEXT_PUBLIC_API_URL`. The exception is the
 * Russia mirror: RKN throttles Cloudflare edge IPs on RU consumer ISPs, so RU
 * users reach the app under `*.getfacade.ru` (a non-Cloudflare relay, see
 * deployment/ru-proxy) instead of `*.getfacade.ai`. When we detect we're being
 * served from a getfacade.ru host, point the API (and, transitively, every
 * absolute URL the API rewrites) at the `.ru` sibling — so a single build serves
 * both audiences with no separate `.ru` image.
 *
 * SSR-safe: `window` is undefined on the server, where we always use the env value.
 */
export function resolveApiUrl(): string {
  const envUrl = process.env.NEXT_PUBLIC_API_URL;

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'getfacade.ru' || host.endsWith('.getfacade.ru')) {
      return 'https://api.getfacade.ru';
    }
  }

  if (!envUrl) {
    throw new Error('NEXT_PUBLIC_API_URL environment variable is not defined');
  }

  return envUrl;
}
